import { render, staticRenderFns } from "./ReportingLegacy.vue?vue&type=template&id=6ed3e0e0"
import script from "./ReportingLegacy.vue?vue&type=script&lang=js"
export * from "./ReportingLegacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ed3e0e0')) {
      api.createRecord('6ed3e0e0', component.options)
    } else {
      api.reload('6ed3e0e0', component.options)
    }
    module.hot.accept("./ReportingLegacy.vue?vue&type=template&id=6ed3e0e0", function () {
      api.rerender('6ed3e0e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/section/ReportingLegacy.vue"
export default component.exports